import React from 'react';
import ReportGenerator from '../components/reports/ReportGenerator';
import PageHeader from '../components/common/PageHeader';

export default function Reports() {
  return (
    <div>
      <PageHeader title="Reports" subtitle="Generate and download detailed reports" />
      <ReportGenerator />
    </div>
  );
}